import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Button, Grid } from '@mui/material';
import axios from 'axios';

const Integrations = () => {
  const [integrations, setIntegrations] = useState([]);

  useEffect(() => {
    fetchIntegrations();
  }, []);

  const fetchIntegrations = async () => {
    try {
      const res = await axios.get('/api/integrations');
      setIntegrations(res.data);
    } catch {
      setIntegrations([]);
    }
  };

  const handleConnect = async (id) => {
    try {
      await axios.post(`/api/integrations/${id}/connect`);
      fetchIntegrations();
    } catch {}
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>Entegrasyonlar</Typography>
      <Grid container spacing={2}>
        {integrations.map((i) => (
          <Grid item xs={12} sm={6} key={i.id}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6">{i.name}</Typography>
              <Typography variant="body2">{i.desc}</Typography>
              <Typography variant="caption" color="success.main">{i.status}</Typography>
              <Button variant="contained" disabled={i.connected} sx={{ mt: 1 }} onClick={() => handleConnect(i.id)}>
                {i.connected ? 'Bağlandı' : 'Bağlan'}
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Integrations;
